export default "__VITE_ASSET__Dr40hfzl__"